export const links = {
  baseURL: 'https://api.mheroqatar.com',
  uploads: 'https://api.mheroqatar.com/uploads/',

  // baseURL: "http://169.254.233.159:8080",
  // uploads: "http://169.254.233.159:8080/uploads/",
  // baseURL: "http://192.168.0.146:8080",
  // baseURL: 'http://localhost:8081',
  // uploads: "http://192.168.0.146:8080/api/v1/uploads",
  // uploads: 'http://localhost:8080/api/v1/uploads',
  home: {
    slideshow: 'slideshow',
    service: 'service',
    settings: 'setting/65de4f50e362d71f317f96eb',
    product: 'product',
    client: 'client',
    brand: 'brand',
    news: 'news',
    productsearch: 'productsearch',
    category: 'productcategory',
    photoGallery: 'photoGallery',
  },
  contact: 'contact',
};
